import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useState } from 'react';
import s from './Modal.module.css';
import { Cross } from 'components/iconComponent/Cross';
import { BackgroundUpload } from 'components/iconComponent/BackgroundUpload';
import { useNavigate } from 'react-router-dom';
import { UploadButton } from './UploadButton';
import { uploadImage } from 'services/API/API';
import { LogApproved, LogNotApproved } from 'components/Log/Log';

const modalRoot = document.querySelector('#modal');

function Modal() {
  const [isOpen, setIsOpen] = useState(true);
  const [isImage, setIsImage] = useState(false);
  const [image, setImage] = useState(null);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [approved, setApproved] = useState(false);
  const [status, setStatus] = useState(false);

  const naigate = useNavigate();

  useEffect(() => {
    const checkButton = e => {
      if (e.code === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('keydown', checkButton);

    return () => {
      document.removeEventListener('keydown', checkButton);
    };
  }, [isOpen]);

  const onClick = e => {
    setIsOpen(false);
    naigate('/gallery', { replace: true });
  };

  const handlerOverlayClick = e => {
    if (e.target === e.currentTarget) {
      console.log(e.target);
      console.log(e.currentTarget);
      naigate('/gallery', { replace: true });
      setIsOpen(false);
    }
  };

  const handleFile = e => {
    const fileObj = e.target.files && e.target.files[0];
    if (!fileObj) {
      return;
    }

    setIsImage(fileObj.type === 'image/png' || fileObj.type === 'image/jpeg');
    setStatus(false);
    setFileName(fileObj.name);
    setFile(fileObj);
    setImage(URL.createObjectURL(fileObj));
  };

  const uploadHandler = e => {
    const formData = new FormData();
    console.log(approved);
    formData.append('file', file);
    uploadImage(formData).then(data => {
      if (data) {
        setApproved(true);
        setIsImage(false);
        setStatus(false);
      } else {
        setApproved(false);
      }
      setStatus(true);
    });
  };

  return createPortal(
    isOpen && (
      <div className={s.Overlay} onClick={handlerOverlayClick}>
        <div className={s.Modal}>
          <button className={s.close__button} onClick={onClick}>
            <Cross />
          </button>
          <div className={s.text__bold}>Upload a .jpg or .png Cat Image</div>
          <div className={s.text__second}>
            Any uploads must comply with the{' '}
            <a
              href="https://thecatapi.com/privacy"
              className={s.link}
              target="_blank"
              rel="noreferrer"
            >
              upload guidelines
            </a>
            or face deletion.
          </div>

          <div
            className={
              !status || approved ? s.input__area : s.input__area__error
            }
          >
            <label for="file-upload" className={s.upload__label}>
              {isImage ? (
                <img src={image} className={s.image} alt={'no cats'} />
              ) : (
                <BackgroundUpload />
              )}
              {!isImage && (
                <div className={s.text__uploadarea}>
                  Drag here <span>your file or</span> Click{' '}
                  <span>to upload</span>
                  here
                </div>
              )}
            </label>

            <input type="file" id="file-upload" onChange={handleFile} />
            {isImage && !approved ? (
              <div className={s.status}>Image File Name: {fileName}</div>
            ) : (
              <div className={s.status}>No file selected</div>
            )}
            {isImage && !status && <UploadButton onclick={uploadHandler} />}
            {status && approved && <LogApproved />}
            {isImage && !approved && status && <LogNotApproved />}
          </div>
        </div>
      </div>
    ),
    modalRoot
  );
}

export { Modal };
